export default {
  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  address: "Address",
  balance: "Balance",
  operation: "Operation",

  // Actions
  viewDetails: "View Details",

  // Empty state
  noData: "No data",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",

  // Message prompts
  copySuccess: "Copy successful!",
};
